import React from 'react';
import { connect } from 'react-redux';
import { translate } from '../../base/i18n/functions';
import { IconE2EE } from '../../base/icons/svg';
import Label from '../../base/label/components/web/Label';
import { COLORS } from '../../base/label/constants';
import Tooltip from '../../base/tooltip/components/Tooltip';
const E2EELabel = ({ _e2eeLabels, _showLabel, t }) => {
    if (!_showLabel) {
        return null;
    }
    const content = _e2eeLabels?.tooltip || t('e2ee.labelToolTip');
    return (React.createElement(Tooltip, { content: content, position: 'bottom' },
        React.createElement(Label, { color: COLORS.lightGreen, icon: IconE2EE, className: 'e2eeLabel' })));
};
/**
 * Maps (parts of) the redux state to the associated props of this {@code Component}.
 *
 * @param {Object} state - The redux state.
 * @private
 * @returns {IProps}
 */
export function _mapStateToProps(state) {
    const { e2ee = {} } = state['features/base/config'];
    return {
        _e2eeLabels: e2ee.labels,
        _showLabel: state['features/base/participants'].numberOfParticipantsDisabledE2EE === 0
    };
}
export default translate(connect(_mapStateToProps)(E2EELabel));
